export default function RefundPolicy() {
  return (
    <div className="pt-32 lg:pt-40 pb-24" data-testid="refund-policy-page">
      <div className="container-x max-w-3xl">
        <p className="section-label">LEGAL</p>
        <h1 className="mt-5 font-heading text-4xl sm:text-5xl font-black tracking-tight text-white">REFUND POLICY</h1>
        <div className="mt-8 space-y-5 text-sm text-slate-400 leading-relaxed">
          <p>All Built2Last.live development engagements are prepaid after scope approval. Because development capacity is reserved and work begins promptly, we do not automatically offer full refunds.</p>
          <p>Refund treatment considers: whether development has started, work already completed, third-party costs incurred, Rush Hour booking commitments, specialist availability reserved, client cancellation timing and project scope.</p>
          <p>If Built2Last.live cannot begin an approved and paid engagement, the unused prepaid amount is refundable.</p>
          <p>Refunds, where approved, are initiated to the original payment method via Razorpay. Refund timing depends on the payment method, Razorpay processing and banking systems, and can take several business days; international payments can take longer.</p>
          <p>To request a refund, contact support@built2last.live with your payment or invoice reference.</p>
          <p className="text-xs text-slate-600">This policy should be reviewed by qualified legal counsel before production launch.</p>
        </div>
      </div>
    </div>
  );
}
